export function capitalizeFirstLetter(string) {
    return string
        .toLowerCase()  // Convertit tout en minuscules
        .split(' ')     // Sépare les mots
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Met en majuscule la première lettre de chaque mot
        .join(' ')      // Rejoint les mots en une seule chaîne
}